// v3.15-1088 — Small UX bits used by every email modal that consumes
// TemplateSelector. Kept here so each modal stays small.

import React from 'react';
import { FileText } from 'lucide-react';

/**
 * Banner shown immediately after a template is loaded into the modal.
 * Parallels the v3.15-1079 "Auto-generated draft" banner — same colour
 * palette, same placement above Subject. Auto-hides when `template` is null.
 */
export const TemplateLoadedBanner = ({ template, testId = 'template-loaded-banner' }) => {
  if (!template) return null;
  return (
    <div
      className="rounded bg-blue-50 border border-blue-200 px-2.5 py-1.5 text-[11px] text-blue-800 leading-snug flex items-start gap-1.5"
      data-testid={testId}
    >
      <FileText className="h-3 w-3 mt-0.5 flex-shrink-0" />
      <span>
        <span className="font-medium">{template.name}</span> loaded.
        {' '}Subject and body may be edited before sending.
      </span>
    </div>
  );
};

/**
 * Resolves whether to replace the operator's current draft when they pick a
 * new template. Returns true if it's OK to overwrite, false if the operator
 * cancels. Uses window.confirm so it works inside any Dialog without extra
 * modal-stacking gymnastics.
 *
 * @param current    { subject, body } currently in the editor
 * @param initial    { subject, body } snapshot captured when the modal opened
 *                   OR when the last template was loaded (whichever happened
 *                   most recently)
 */
export const confirmReplaceDraft = (current, initial) => {
  const isDirty =
    (current?.subject || '').trim() !== (initial?.subject || '').trim() ||
    (current?.body    || '').trim() !== (initial?.body    || '').trim();
  if (!isDirty) return true;
  return window.confirm(
    'You have modified this draft. Loading a new template will replace your current edits. Continue?'
  );
};
